export default __webpack_public_path__ + "static/media/ConfiguracaoIconWhite.c79f1062.svg";